/* ============================================================
   Germano Agustini — guia de aro em popup na página de produto

   Reusa o MinimogTheme.Modal do próprio tema: mesma sobreposição,
   mesmo botão de fechar, mesma tecla Escape do quick view. Nada de
   modal próprio.

   O link continua sendo um <a> real com href e target="_blank":
   sem JS, ou em clique com Ctrl/Cmd, o navegador abre a página
   normalmente. O popup é melhoria, não pré-requisito.
   ============================================================ */

(function () {
  'use strict';

  var GUIA_PATH = 'pages/como-medir';
  var TEMPLATE_COMPACTO = 'como-medir-compacto';
  var CLASSES_MODAL = 'm-gradient m-color-germano-stone ga-modal';

  var modal = null;
  var secaoCache = null;
  var carregando = false;
  var assetsProntos = false;

  function temSuporte() {
    return !!(window.MinimogTheme && window.MinimogTheme.Modal && window.DOMParser && window.fetch);
  }

  function baseUrl() {
    var s = window.MinimogSettings;
    return s && s.base_url ? s.base_url : '/';
  }

  /* Copia <link> e <style> que vieram com a seção. A folha de estilo
     da seção só existe na página do guia; na PDP ela ainda não está. */
  function absorverEstilos(dom) {
    var pendentes = [];

    dom.querySelectorAll('link[rel="stylesheet"]').forEach(function (link) {
      var href = link.getAttribute('href');
      if (!href || href.indexOf('ring-sizer') === -1) return;
      var arquivo = href.split('?')[0];
      var jaExiste = Array.prototype.some.call(
        document.querySelectorAll('link[rel="stylesheet"]'),
        function (l) { return (l.getAttribute('href') || '').split('?')[0] === arquivo; }
      );
      if (jaExiste) return;

      var novo = document.createElement('link');
      novo.rel = 'stylesheet';
      novo.href = href;
      pendentes.push(new Promise(function (resolve) {
        novo.onload = resolve;
        novo.onerror = resolve; /* falha de CSS não pode travar a abertura */
      }));
      document.head.appendChild(novo);
    });

    /* O <style> inline carrega as variáveis da seção (cor de destaque
       e espaçamentos), então precisa vir junto ou o desenho quebra. */
    dom.querySelectorAll('style').forEach(function (tag) {
      if (tag.textContent.indexOf('--ga-accent') === -1) return;
      var marca = tag.textContent.slice(0, 60);
      var duplicado = Array.prototype.some.call(
        document.head.querySelectorAll('style[data-ga-modal-style]'),
        function (t) { return t.textContent.slice(0, 60) === marca; }
      );
      if (duplicado) return;
      var novo = document.createElement('style');
      novo.setAttribute('data-ga-modal-style', '');
      novo.textContent = tag.textContent;
      document.head.appendChild(novo);
    });

    return Promise.all(pendentes);
  }

  /* Script injetado por innerHTML não executa: tem que recriar a tag. */
  function absorverScript(dom) {
    return new Promise(function (resolve) {
      var origem = dom.querySelector('script[src*="ring-sizer"]');
      if (!origem) return resolve();

      var src = origem.getAttribute('src');
      var arquivo = src.split('?')[0];
      var jaExiste = Array.prototype.some.call(
        document.querySelectorAll('script[src]'),
        function (s) { return (s.getAttribute('src') || '').split('?')[0] === arquivo; }
      );
      if (jaExiste) return resolve();

      var novo = document.createElement('script');
      novo.src = src;
      novo.onload = resolve;
      novo.onerror = resolve;
      document.head.appendChild(novo);
    });
  }

  function buscarSecao() {
    if (secaoCache) return Promise.resolve(secaoCache);

    var url = baseUrl() + GUIA_PATH;

    /* Não uso a Section Rendering API aqui: ela exige o id prefixado
       com o número interno do template (template--000000__main), que
       muda a cada republicação da página e não dá para fixar no código.
       Buscar a página e recortar a seção é mais lento uma vez só, e
       não quebra sozinho depois. */
    function tentar(view) {
      var alvo = view ? url + '?view=' + view : url;
      return fetch(alvo, { credentials: 'same-origin' })
        .then(function (res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.text();
        })
        .then(function (texto) {
          var dom = new DOMParser().parseFromString(texto, 'text/html');
          var secao = dom.querySelector('[data-ga-sizer]');
          if (!secao) throw new Error('seção não encontrada em ' + alvo);
          return absorverEstilos(dom)
            .then(function () { return absorverScript(dom); })
            .then(function () { return document.adoptNode(secao); });
        });
    }

    /* Versão enxuta primeiro. Se o template alternativo não resolver,
       cai para a página completa em vez de deixar o cliente sem nada. */
    return tentar(TEMPLATE_COMPACTO)
      .catch(function () { return tentar(null); })
      .then(function (secao) {
        secaoCache = secao;
        assetsProntos = true;
        return secao;
      });
  }

  function abrir(gatilho) {
    if (carregando) return;
    carregando = true;
    if (gatilho) gatilho.classList.add('m-spinner-loading');

    buscarSecao()
      .then(function (secao) {
        if (!modal) modal = new window.MinimogTheme.Modal();
        modal.appendChild(secao);
        modal.setWidth('min(1040px, 100%)');
        modal.open();
        modal.setSizes(CLASSES_MODAL);

        /* A seção se inicializa sozinha ao ouvir este evento do Shopify,
           que é o mesmo caminho usado pelo editor de temas. */
        document.dispatchEvent(new Event('shopify:section:load'));
      })
      .catch(function (erro) {
        /* Sem popup, o link vira navegação normal. */
        console.error('[guia de aro] popup indisponível, abrindo a página:', erro);
        if (gatilho && gatilho.href) window.open(gatilho.href, gatilho.target || '_self');
      })
      .then(function () {
        carregando = false;
        if (gatilho) gatilho.classList.remove('m-spinner-loading');
      });
  }

  /* Pré-carrega ao passar o mouse ou focar pelo teclado. Quem vai
     clicar normalmente hesita alguns décimos sobre o link, e isso
     cobre boa parte do tempo de busca. Só dispara uma vez. */
  var prefetchado = false;
  function prefetch() {
    if (prefetchado || carregando || secaoCache || !temSuporte()) return;
    prefetchado = true;
    buscarSecao().catch(function () { prefetchado = false; });
  }
  ['mouseenter', 'focusin', 'touchstart'].forEach(function (evt) {
    document.addEventListener(evt, function (ev) {
      if (ev.target.closest && ev.target.closest('.ga-size-help')) prefetch();
    }, { capture: true, passive: true });
  });

  document.addEventListener('click', function (ev) {
    var gatilho = ev.target.closest ? ev.target.closest('.ga-size-help') : null;
    if (!gatilho) return;

    /* Ctrl, Cmd, Shift ou botão do meio: respeita a intenção de abrir
       em outra aba, que é comportamento esperado de link. */
    if (ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.button === 1) return;
    if (!temSuporte()) return; /* deixa o href agir */

    ev.preventDefault();
    abrir(gatilho);
  });
})();
